import _extends from "@babel/runtime/helpers/extends";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _callSuper from "@babel/runtime/helpers/callSuper";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _templateObject;
import React from 'react';
import { css, Global } from '@emotion/react';
import ReactDOM from 'react-dom';
import { notifyError } from '../Notification/NotificationHost';
import { withTranslate } from '../util';
import { ErrorBoundary } from '../util/ErrorBoundary';
import { bladeOverlayAnimationDurationMS } from './BladeOverlay.styled';
export function withBlades(Component) {
  var _WithBlades = /*#__PURE__*/function (_React$Component) {
    function WithBlades() {
      var _this;
      _classCallCheck(this, WithBlades);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _callSuper(this, WithBlades, [].concat(args));
      _defineProperty(_this, "state", {
        blade: null
      });
      _defineProperty(_this, "showBlade", function (element) {
        var domNode = _this.createPortal();
        var isClosing = false;
        var blade = {
          element: element,
          disposing: false,
          domNode: domNode,
          onDismiss: function onDismiss() {
            _this.disposeBlade(blade);
            if (!isClosing && element.props.onDismiss) {
              isClosing = true;
              element.props.onDismiss();
            }
          }
        };
        _this.setState({
          blade: blade
        });
      });
      _defineProperty(_this, "disposeBlade", function (blade) {
        _this.setState({
          blade: _objectSpread(_objectSpread({}, blade), {}, {
            disposing: true
          })
        });
        setTimeout(function () {
          _this.destroyPortal(blade.domNode);
          _this.setState({
            blade: null
          });
        }, bladeOverlayAnimationDurationMS);
      });
      _defineProperty(_this, "onError", function () {
        var _this$state$blade, _this$state$blade$onD;
        notifyError(_this.props.t('citrix-ui:generic_error_message'));
        (_this$state$blade = _this.state.blade) === null || _this$state$blade === void 0 ? void 0 : (_this$state$blade$onD = _this$state$blade.onDismiss) === null || _this$state$blade$onD === void 0 ? void 0 : _this$state$blade$onD.call(_this$state$blade);
      });
      return _this;
    }
    _inherits(WithBlades, _React$Component);
    return _createClass(WithBlades, [{
      key: "render",
      value: function render() {
        return /*#__PURE__*/React.createElement(React.Fragment, null, this.state.blade && /*#__PURE__*/React.createElement(Global, {
          styles: css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\tbody {\n\t\t\t\t\t\t\t\t\toverflow: hidden;\n\t\t\t\t\t\t\t\t\tposition: fixed;\n\t\t\t\t\t\t\t\t\twidth: 100%;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t"])))
        }), /*#__PURE__*/React.createElement(Component, _extends({}, this.props, {
          showBlade: this.showBlade
        })), this.state.blade && /*#__PURE__*/React.createElement(ErrorBoundary, {
          onError: this.onError
        }, this.createBladePortal(this.state.blade)));
      }
    }, {
      key: "createPortal",
      value: function createPortal() {
        var portal = document.createElement('div');
        document.body.appendChild(portal);
        return portal;
      }
    }, {
      key: "destroyPortal",
      value: function destroyPortal(portal) {
        document.body.removeChild(portal);
      }
    }, {
      key: "createBladePortal",
      value: function createBladePortal(blade) {
        var element = /*#__PURE__*/React.cloneElement(blade.element, {
          onDismiss: blade.onDismiss,
          isOpen: !blade.disposing
        });
        return /*#__PURE__*/ReactDOM.createPortal(element, blade.domNode);
      }
    }]);
  }(React.Component);
  return withTranslate(_WithBlades);
}